module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Boston Light")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "template.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title-head1",
    attrs: {
      "id": "Ack"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CKNOWLEDGMENTS")])])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "para1"
  }, [_vm._v("Photographs within this book were provided as a courtesy from a number of individuals and organizations, as well as from the authors’ collection. Others were helpful in the search for photographs and illustrations. Heartfelt gratitude is given for the assistance provided by the following, with apologizes to anyone inadvertently omitted: James Claflin, Candace Clifford, Hugh Daugherty, Jeremy D’Entremont, Willie Emerson, Friends of Flying Santa, the Gatcomb family, Historic New England, Hull Lifesaving Museum, Giacinta Bradley Koontz, James Lampke, Pilgrim Congregational Church, Dolly Snow Bicknell, Thomas A. Tag, Brian Tague, Tufts Medical Center, Shea Naval Aviation Museum, Victoria Stevens, Audrey and Richard Tessier, Sydney Underwood, US Coast Guard, US Coast Guard Historian’s Office, Lynn Waller, and George Ward. We greatly appreciate the technical support we received from Jennifer Richardson, John Richardson, and Brian Tague; the proofreading of avid supporter Shirley Snowman Richardson; and the infinite encouragement of Beverly Snowman DeMorat and Kelly Richardson Schofield.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-313efe6a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Acknowledgments.vue
// module id = 75
// module chunks = 0